module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e17-5075f419a67d5263f76d15d5d6196843.jpg";